<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="true" :onConfigReady="onQueryConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" name="btns">
            <template>
                <div class="left"></div>
                <div class="right">
                    <a class="swb-btn swb-btn-small swb-btn-primary" @click="exportAllAsExcel">导出</a>
                    <a class="swb-btn swb-btn-small swb-btn-primary" @click="generalImport">组装件定义导入</a>
                </div>
            </template>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'
    import { showGrpDownloadDlg, showDownloadDlg } from '../ctrl/dialog'
    import { openBigImgDlg } from '../comn/dialog'
    import { openAsmblAccDefImpCheckDlg, openAsmblAccDefFormatExplDlg } from './dialog'
    import { fileUploadGroupShowDlg } from '../comn/dialog'
    import {
        loadRetailerDevcGroupList, loadAssetKindList
    } from '../retailer/asset-comn'

    import asmblAccApi from '../../api/asmblAcc'
    import userApi from '../../api/user';

    import SwbAsmblAccDefSave from './AsmblAccDefSave';
    Vue.regist(SwbAsmblAccDefSave);

    import SwbMerchtDevcAsset from '../devcDef/MerchtDevcAsset';
    Vue.regist(SwbMerchtDevcAsset);

    export default {
        name: 'swb-asmbl-acc-def-list',
        path: '/asmbl/acc/def/list',
        desc: '组装件定义管理',
        props: {
            ids: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            viewFlag: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            return {
                // 分页信息
                pageNumber: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                lastPageNumber: null,
                //
                confKey: 'swb-asmbl-acc-def-list',
                theTableHeight: 450,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: true, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                //
                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                btnColFixed: true, //操作列是否固定
                // 过滤信息
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                scopeEntity: null,
                exportParmas: null
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            if(Utils.isTrue(this.viewFlag)) {
                this.btnColName = '';
            }
            let id = this.$route.query.id || null;
            if(!Utils.isNoB(id)) {
                this.ids.push(id);
            }
            this.getCurrUserInfo();
        },
        mounted() {
            let self = this;
            if(!Utils.isTrue(this.viewFlag)) {
                //注册domSizeWatcher
                let thisEl = $(this.$el);
                $(this.$el).addClass('overflow-hidden');
                //
                let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
                domSizeWatcher.setBaseEl(thisEl);
                domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                    //根据新主元素的内容大小，调整表格高度
                    self.theTableHeight = height;
                });
                //domSizeWatcher.setHrEls();
                domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"], [name="btns"]'));
                domSizeWatcher.start(500);
            }
            //
            this.initResultTable();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            getCurrUserInfo(){
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == 'info') {
                        self.scopeEntity = result.data.scopeEntity;
                    }
                });
            },
            onQueryConfigReady: function () {
                this.initAsyncQueryModel();
            },
            initAsyncQueryModel() {
                let self = this;
                // 分类分组
                loadRetailerDevcGroupList(function (dataList) {
                    self.updateQueryModelField("devcGroupId", dataList);
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'imageUrl': function (row, colName, colValue, rowIndex, colConf) {
                        if(!Utils.isNoB(row.imageUrl)) {
                            return '<a href="#"><img style="height: 36px;width: 36px" src="' + row.imageUrl + '"/></a>';
                        } else {
                            return "";
                        }
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let domHtml = '';
                        if(self.checkActionPerm('modify') && row.createRetailerId == self.scopeEntity.id) {
                            domHtml = domHtml + '<a name="modify" class="swb-btn swb-btn-link">编辑</a>';
                        }
                        if(self.checkActionPerm('disabled') && row.createRetailerId == self.scopeEntity.id) {
                            domHtml = domHtml + '<a name="disabled" class="swb-btn swb-btn-link">' + (row.disabled ? '启用' : '禁用') + '</a>';
                        }
                        //
                        if(self.checkActionPerm('delete') && row.disabled && row.createRetailerId == self.scopeEntity.id) {
                            domHtml = domHtml + '<a name="delete" class="swb-btn swb-btn-link">删除</a>';
                        }
                        if(self.checkActionPerm('set_adopted_device') && !row.disabled) {
                            domHtml = domHtml + '<a name="set_adopted_device" class="swb-btn swb-btn-link">组装件商品</a>';
                        }
                        return domHtml;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'imageUrl': function (row, colName, colValue, rowIndex, btnName) {
                        self.viewImage(row.imageUrl);
                    },
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'modify') {
                            self.toAsmblDefAdd(row.id);
                        } else if(btnName == 'disabled') {
                            self.doDisabled(row.id, row.disabled);
                        } else if(btnName == 'delete') {
                            self.deleteAsmblAccDef(row.id);
                        } else if(btnName == 'set_adopted_device') {
                            self.toSetAdoptedDevice(row);
                        }
                    }
                });
            },
            viewImage: function (fileBrowseUrl) {
                openBigImgDlg(fileBrowseUrl);
            },
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                this.getDataList();
            },
            //
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getDataList();
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            //
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            getDataList(){
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if(!Utils.isNoB(self.ids) && self.ids.length > 0) {
                    filterItems.ids = self.ids;
                }
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                self.exportParmas = filterItems;
                let theLoading = MsgBox.loading();
                asmblAccApi.getAsmblAccDefList(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        //
                        self.renderTable(result.data.rows, result.data.pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            toAsmblDefAdd(id){
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '组装件定义 - ' + Utils.isNoB(id) ? "新增" : "修改",
                    width: 1000,
                    height: 850,
                    showCloseBtn: true,
                    template: '<swb-asmbl-acc-def-save :defId="defId" ref="swb_asmbl_acc_def_save"></swb-asmbl-acc-def-save>',
                    data: {
                        defId: id,
                    },
                    okClicked: function () {
                        let resultData = this.$refs.swb_asmbl_acc_def_save.getDlgResult();
                        if(resultData.type == 'info') {
                            let asmblAccDef = resultData.data;
                            let msgBoxDlg = MsgBox.loading();
                            if(id == null) {
                                asmblAccApi.saveAsmblAccDef(asmblAccDef, function (result) {
                                    msgBoxDlg.close();
                                    if(result.type == "info") {
                                        theDlg.close();
                                        MsgBox.success('操作成功!');
                                        self.getDataList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            } else {
                                asmblAccApi.updateAsmblAccDef(asmblAccDef, function (result) {
                                    msgBoxDlg.close();
                                    if(result.type == "info") {
                                        theDlg.close();
                                        MsgBox.success('操作成功!');
                                        self.getDataList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                            }
                        } else {
                            MsgBox.warning(resultData.message);
                        }
                        return false;
                    }
                });
            },
            doDisabled(id, disabled){
                let self = this;
                this.$confirm('确定' + (disabled ? '启用' : '禁用') + '吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        id: id,
                        disabled: !disabled
                    };
                    let theLoad = MsgBox.loading();
                    asmblAccApi.doAsmblAccDefDisabled(postData, function (result) {
                        if(result.type == "info") {
                            theLoad.hide();
                            MsgBox.success("操作成功!");
                            self.getDataList();
                        } else {
                            MsgBox.warning(result.message);
                            theLoad.hide();
                        }
                    });
                }).catch(function () {

                });
            },
            deleteAsmblAccDef(id){
                let self = this;
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {
                        id: id,
                    };
                    let theLoad = MsgBox.loading();
                    asmblAccApi.deleteAsmblAccDef(postData, function (result) {
                        theLoad.hide();
                        if(result.type == "info") {
                            MsgBox.success("操作成功!");
                            self.getDataList();
                        } else {
                            MsgBox.warning(result.message);
                        }
                    });
                }).catch(function () {
                });
            },
            // 资产商品
            toSetAdoptedDevice(row) {
                // 查看条件
                let showFilter = {
                    assetDefId: row.id,
                    asmblAccFlag: true
                };
                // 关联条件
                let filter = {
                    catId: row.catId,
                    brandId: row.brandId,
                    asmblAccFlag: true
                };
                //
                let theDlg = Vue.$showDialog({
                    title: "资产商品",
                    width: -400,
                    height: 900,
                    cancelVisible: true,
                    cancelText: "关闭",
                    okVisible: false,
                    template: '<swb-mercht-device-asset-set :asmblAccFlag="asmblAccFlag" :showFilter="showFilter" :filter="filter" :asmblAccDefId="asmblAccDefId" :notAssetDefFlag="notAssetDefFlag" :centBuyRequired="centBuyRequired" ref="swb_adopted_device_list_select"></swb-mercht-device-asset-set>',
                    data: {
                        showFilter: showFilter,
                        filter: filter,
                        asmblAccDefId: row.id,
                        centBuyRequired: row.centBuyRequired,
                        asmblAccFlag: true,
                        notAssetDefFlag: true,
                    }
                });
            },
            // 导入说明
            // showFormatElpx: function () {
            //     openAsmblAccDefFormatExplDlg();
            // },
            // 下载资产定义导入模板
            downloadTemplate: function () {
                // 下载模版
                let url = "/api/asmbl/acc/def/imp/model/template/file/download";
                Utils.setPageUrl(getAppUrl(url), '_blank');
            },
            // 导入资产定义
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('请选择要上传的文件');
                    return false;
                }
                this.theLoader = MsgBox.loading("正在解析资产文件");
            },
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            onUploadDone: function (result) {
                let self = this;
                self.theLoader.hide();
                if(result.type === 'info') {
                    let files = result.data.files;
                    self.file = files[0];
                    // 文件是否按模版导入
                    let errorMsgList = self.file.extra.errorMsgList;
                    if(!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                        MsgBox.warning(errorMsgList.join("<br/>"));
                        return;
                    }
                    // 验证此文件中导入的内容
                    self.openMerchtDevcDefImpCheckDlg(self.file);
                } else {
                    MsgBox.warning(result.message);
                }
            },
            // 导入内容校验
            openMerchtDevcDefImpCheckDlg (fileObj) {
                let self = this;
                // 先调用一次检验方法
                let devcDefImpDto = {
                    originalFileName: fileObj.extra.originalFileName,
                    impInfoList: fileObj.extra.impInfoList || [],
                };
                // 大于500条目不能执行统一检查
                if(devcDefImpDto.impInfoList.length > 500) {
                    let fileObj = {
                        extra: {
                            originalFileName: devcDefImpDto.originalFileName,
                            impInfoList: devcDefImpDto.impInfoList
                        }
                    };
                    openAsmblAccDefImpCheckDlg(fileObj, function (devcDefImpResult) {
                        // 导入后回调的方法,刷新列表
                        self.getDataList();
                        //
                        let importStatis = devcDefImpResult.importStatis;
                        if(importStatis != null) {
                            MsgBox.info("导入资产定义总数量：{0}个".format(importStatis.devcDefCount));
                        } else {
                            MsgBox.info("执行完毕");
                        }
                    });
                } else {
                    //
                    let theLoading = MsgBox.loading("正在检查导入数据");
                    asmblAccApi.validateAsmblAccDefImpModel(devcDefImpDto, function (result) {
                        theLoading.close();
                        let impDto = result.data;
                        let fileObj = {
                            extra: {
                                originalFileName: impDto.originalFileName,
                                impInfoList: impDto.impInfoList
                            }
                        };
                        openAsmblAccDefImpCheckDlg(fileObj, function (devcDefImpResult) {
                            // 导入后回调的方法,刷新列表
                            self.getDataList();
                            //
                            let importStatis = devcDefImpResult.importStatis;
                            if(importStatis != null) {
                                MsgBox.info("导入资产定义总数量：{0}个".format(importStatis.devcDefCount));
                            } else {
                                MsgBox.info("执行完毕");
                            }
                        });
                    });
                }
            },
            generalImport: function () {
                let self = this;
                let uploadParams = {
                    title: "组装件定义导入",
                    fileGroup: "asmblAcc.import",
                    multipleFile: false,
                    usage: 'asmblAcc.import'
                };
                fileUploadGroupShowDlg(uploadParams, "/api/asmbl/acc/def/imp/model/template/file/download?usage=asmblAcc.import", function (result, theDlg) {
                    // theDlg 关闭弹框
                    theDlg.close();
                    if(result.type === 'info') {
                        let files = result.data.files;
                        self.file = files[0];
                        // 文件是否按模版导入
                        let errorMsgList = self.file.extra.errorMsgList;
                        if(!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                            MsgBox.warning(errorMsgList.join("<br/>"));
                            return;
                        }
                        // 验证此文件中导入的内容
                        self.openMerchtDevcDefImpCheckDlg(self.file);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            exportAllAsExcel(type) {
                let title = "组装件定义";
                let fileName = title + new Date().format('yyyy_MM_dd') + '.xlsx';
                let url = getAppUrl("/file/export/as/excel");
                let tableData = this.getTableData(null, null, type);
                let data = Utils.merge({
                    //指示要一次性单个文件全部导出（最大导出条数 受限于 系统参数 "Xls全量导出最大行数限制"）
                    exportAllAtOnce: true,
                    //指示分批请求数据条目数（每条字段数越大，此值应该越小，【可选】，默认取值（并受限）于系统参数 "Xls全量导出每批量数限制"）
                    exportBatchSize: 1000,
                    //
                    fileName: fileName
                }, tableData);
                let fileInfo = {
                    url: url,
                    post: true,
                    fileName: fileName,
                    data: data
                };
                showDownloadDlg(title, fileInfo);
            },
            getTableData(pages, pageSize){
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                delete tableData.rows;//减少数据传输量
                //
                let rowsSrc = {};
                rowsSrc.data = this.getPostData();
                rowsSrc.url = "/asmbl/acc/def/list/get";
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData(){
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportParmas);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let multipleSelection = this.getTableSelection();
                if(multipleSelection.length > 0) {
                    let ids = [];
                    multipleSelection.forEach(function (el) {
                        ids.push(el.id);
                    });
                    filterItems.ids = ids;
                }
                filterItems.exportFlag = true;
                //
                let postData = {};
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/asmblAcc/AsmblAccDefList.vue